module.exports = __webpack_public_path__ + "static/media/ed-hoc.7dc77420.png";